module.exports = __webpack_public_path__ + "img/visa.50296eab.png";